import { useEffect, useState } from 'react';
import { apiGetCaptchaeImg, apiH5RebateApply } from '../api';
import { showToast } from '../utils/utils';
import MessageDialog from '../components/messageDialog';
interface prompt {
  captchaId?: string,
  captchaImg?: string,
  captchaSwitch?: boolean
}
export default function RefundFeePage() {
  const [activatePhone, setactivatePhone] = useState('');
  const [cardNum, setcardNum] = useState('');
  const [captchaCode, setcaptchaCode] = useState('');
  const [messageDialogShow, setmessageDialogShow] = useState('');
  
  const [promptCode, setpromptCode] = useState<prompt>({});
  
  useEffect(() => {
    getCodeImg()
  }, [])
  async function getCodeImg() {
    const res = await apiGetCaptchaeImg()
    if (res?.data?.code === 200) {
      setpromptCode(res?.data?.data || {})
    }
  }
  async function handleSubmit() {
    const res = await apiH5RebateApply({activatePhone,cardNum,captchaId: promptCode.captchaId,captchaCode})
    if(res?.data?.code === 200){
      showToast(res?.data?.msg ??'提交成功')
      getCodeImg()
      setactivatePhone('')
      setcardNum('')
      setcaptchaCode('')
    }else{
      setmessageDialogShow(res?.data?.msg ?? '提交失败')
      getCodeImg()
    }
  }
  return (
    <div className='bw-100 d-flex-c jc-center ai-center' style={{ height: '100vh' }}>

      <img src="/pic/refundFeeHeader.jpg" alt="" className='bw-100 h-220' />
      <div className='bw-100 flex-1' style={{
        background: 'url(/pic/refundFeeCenter.jpg) no-repeat center center',
        backgroundSize: '100% 100%', // 按宽度100%缩放，高度自动
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center'
      }}>
        <div className='d-flex-c ai-center jc-between bh-100 bw-100'>
          <div className='d-flex-c ai-center jc-center pl-30 pr-30'>
            <div className="d-flex-r ai-center jc-center font-size-16 pt-15 pb-15 pl-10 pr-10 bg-555 mt-20">
              <span>激活号码</span>
              <div className="flex-1 d-flex-c ai-end">
                <input
                  className="input text-right font-size-16 border-none bg-555"
                  type="text"
                  maxLength={11}
                  placeholder="请输入您的手机号码"
                  value={activatePhone}
                  onChange={(v) => setactivatePhone(v?.target?.value || '')}
                />
              </div>
            </div>
            <div className="d-flex-r ai-center jc-center font-size-16 pt-15 pb-15 pl-10 pr-10 bg-555 mt-15">
              <span>证件号码</span>
              <div className="flex-1 d-flex-c ai-end">
                <input
                  className="input  text-right font-size-16 border-none bg-555"
                  type="text"
                  maxLength={18}
                  placeholder="请输入您的身份证号"
                  value={cardNum}
                  onChange={(v) => setcardNum(v?.target?.value || '')}
                />
              </div>
            </div>
            <div className="d-flex-r ai-center jc-center font-size-16 pt-15 pb-15 pl-10 pr-10 bg-555 mt-15 ml-20 mr-20">
              <div className=" d-flex-c ai-end">
                <input
                  className="input w-180 font-size-16 border-none bg-555"
                  type="text"
                  maxLength={4}
                  placeholder="请输入图形验证码"
                  value={captchaCode}
                  onChange={(v) => setcaptchaCode(v?.target?.value || '')}
                />
              </div>
              <img src={`data:image/png;base64,${promptCode?.captchaImg}`} alt="" className='w-80 h-30  flex-1' title="点击刷新验证码" onClick={getCodeImg} />
            </div>
          </div>
          
            <div className="btn w-120 bg-red mb-50 p-10 border-radius-8 text-center text-color-white" style={{background:'#e13a3e'}} onClick={handleSubmit}>
              立即领取
            </div>
          
        </div>

      </div>
      {/* <img src="/pic/refundFeeCenter.jpg" alt="" /> */}
      <img src="/pic/refundFeebottom.jpg" alt="" className='bw-100' />
      {!!messageDialogShow && (
              <MessageDialog title="系统提示" message={messageDialogShow} onClose={() => setmessageDialogShow('')} />
      )}
    </div>
  );
}
